import Tag from '@uilib/business-components/Tag';

export const TAG_MAX_WIDTH = 120;

export default function TagWrapper(props) {
    return <Tag {...props} border title maxWidth={TAG_MAX_WIDTH} />;
}
